/**
 * Error codes.
 */
export enum ErrorCodes {
  BadData = 'Bad Data',
  BeforeStateHooksConflict = 'Before State hooks conflict',
  DOMDoesNotMatchJCE = 'DOM Does Not Match JCE',
  ElementAlreadyExists = 'Element Already Exists',
  ElementNotFound = 'Element Not Found',
  IllegalJCECall = 'Illegal JCE Call',
  IncorrectMode = 'Incorrect Mode',
  InvalidStateMachine = 'Invalid State Machine',
  MissingPluginDependency = 'Missing Plugin Dependency',
}
